import React, { PropTypes } from 'react';
import DateUtils from '../../../../../utils/date-utils';
import { FontIcon } from 'material-ui';
import EditSeasonButton from '../../product/edit-season-button';
import R, { complement, isNil, isEmpty } from 'ramda';
const notNil = complement(isNil);
const SingleCancellation = ({
  cancelNum,
  cancelHoursDays,
  composedText,
  additionalRules,
  conditions,
  dateRanges,
  index,
  varyBySeason,
  existingSeasons,
  openAddEditContractDialog,
  classes = {},
}) => (
  <div className={classes[`${index}-prod-cancellation`]}>
    <div
      style={{
        fontSize: '12px',
        marginBottom: '0',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderLeft: '1px solid #bababa',
        borderBottom: '1px solid #bababa',
        borderRight: '1px solid #bababa',
        borderTop: !index ? '1px solid #bababa' : '',
        color: '#262626',
        padding: '4px 8px',
      }}
    >
      <div style={{ color: '#f44336' }}>
        {
          varyBySeason && existingSeasons && existingSeasons.length
          && !DateUtils.isDateRangesWithEmptyDates(dateRanges)
          && !DateUtils.getSeasonNameIfMatch(existingSeasons, dateRanges || []) ? "These dates don't match any seasons." : ''
        }
      </div>
      {
        DateUtils.isDateRangesWithEmptyDates(dateRanges) && openAddEditContractDialog ? (
          <EditSeasonButton
            openAddEditContractDialog={openAddEditContractDialog}
            existingSeasons={existingSeasons}
            seasonRatesIndex={index}
            seasonName={R.path([index, 'seasonName'], existingSeasons)}
            dateRanges={dateRanges}
          />
        ) : dateRanges.map((range, rangeIndex) => {
          return (
            <div key={rangeIndex} className={classes[`${index}-dateRanges-${rangeIndex}`]}>
              {
                DateUtils.displayRange(range, {
                  start: classes[`${index}-dateRanges-${rangeIndex}-seasonStartDate`],
                  end: classes[`${index}-dateRanges-${rangeIndex}-seasonEndDate`],
                })
              }
            </div>);
        })
      }
    </div>
    <div style={{ padding: '4px 8px', borderLeft: '1px solid #bababa', color: 'rgba(0,0,0,0.74)', borderBottom: '1px solid #bababa', borderRight: '1px solid #bababa' }}>

      {
        // conditions !== 'Same as location cancellation policy' ? <b style={{ display: 'inline-block', marginBottom: '8px' }}>Basic Cancellation Rule</b> : <b/>
      }
      {
        notNil(cancelNum) && notNil(cancelHoursDays) ? (
          <div style={{ color: 'rgba(0,0,0,0.74)', paddingLeft: '12px', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
            Cancel at least <b><span className={classes[`${index}-cancelNum`]}>{cancelNum}</span> <span className={classes[`${index}-cancelHoursDays`]}>{cancelHoursDays}</span></b> prior to the date of travel to avoid any cancellation fees.
          </div>
        ) : <span/>
      }
      {
        additionalRules && additionalRules.length ? (
          <div>
            <b style={{ display: 'inline-block', margin: '8px 0' }}>Additional Cancellation Rules</b>
            {
              additionalRules.map((rule, ruleIndex) => (
                <div key={ruleIndex}>
                  {ruleIndex + 1}. If cancelled within <b>{rule.cancelNum}</b> <b>{rule.cancelHoursDays}</b> of the date of <b>{rule.arrivalDeparture}</b>, a fee equivalent to <b>{rule.cancelFee}</b> <b>{rule.feeDollarPercent}</b> <b>{rule.feeBase}</b> will be charged.
                </div>
              ))
            }
          </div>
        ) : <div/>
      }
      {
        // conditions !== 'Same as location cancellation policy' ? <b style={{ display: 'inline-block', margin: '8px 0' }}>Other conditions:</b> : <b/>
      }
      <div style={{ color: 'rgba(0,0,0,0.74)', paddingLeft: '12px', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
        {classes[`${index}-conditions-textblock`] || (conditions === 'NA' ? '' : conditions)}
      </div>
    </div>
  </div>
);

SingleCancellation.propTypes = {
  cancelNum: PropTypes.number,
  cancelHoursDays: PropTypes.string,
  conditions: PropTypes.string,
  dateRanges: PropTypes.array,
  index: PropTypes.number,
};

export default SingleCancellation;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/policies/singleCancellation.jsx